import { call, put } from "redux-saga/effects";
import { toast } from "react-toastify";
import { AxiosResponse } from "axios";
import { apiSollar } from "../../../services/axios";

import {
  loadDischargeSuccess,
  loadDischargeFailure,
  loadReasonsSuccess,
  loadReasonsFailure,
  submitDischargeSuccess,
  submitDischargeFailure,
} from "./actions";
import { DischargeReasonItem, DischargeViewItem } from "./types";

// dados da alta
export function* get({ payload }: any) {
  try {
    const { external_attendance_id } = payload;

    const response: DischargeViewItem = {
      external_company_id: "1",
      external_attendance_id,
      external_patient_id: "999",
      attendance_provider_name: "#12345",
      diagnosis: "Dor abdominal aguda - principal",
      discharge_date: "2025-12-29T18:18:25.917Z",
    };

    yield put(loadDischargeSuccess(response));

    /*
    const response: AxiosResponse = yield call(
      apiSollar.get as any,
      `/apiV2/discharge/infos`,
      {
        params: {
          external_attendance_id,
        },
      }
    );
    yield put(loadDischargeSuccess(response.data));
    */
  } catch (error) {
    toast.error("Erro ao buscar dados da alta.");
    yield put(loadDischargeFailure());
  }
}

//listar motivos de alta
export function* loadReasons({ payload }: any) {
  try {
    const mockReasons = [
      { id: "1", describe: "Alta por melhora" },
      { id: "2", describe: "Transferência de setor" },
      { id: "3", describe: "Encaminhamento para especialista" },
    ];

    yield put(loadReasonsSuccess(mockReasons));

    // const response: AxiosResponse = yield call(
    //   apiSollar.get as any,
    //   `/apiV2/discharge/infos`,
    //   {
    //     params: {
    //       external_attendance_id,
    //     },
    //   }
    // );
    // yield put(loadReasonsSuccess(response.data.reasons));
  } catch (error) {
    toast.error("Erro ao carregar motivos de alta.");
    yield put(loadReasonsFailure());
  }
}

// Botao de alta
export function* submit({ payload }: any) {
  try {
    const {
      external_company_id,
      external_attendance_id,
      external_patient_id,
      discharge,
      created_by,
    } = payload;

    const now = new Date().toISOString();

    const mockResponse = {
      _id: external_attendance_id,
      external_company_id,
      external_attendance_id,
      external_patient_id,
      company_id: external_company_id,
      discharge_date: now,
      discharge: {
        external_reason: {
          id: discharge.external_reason.id,
          describe: discharge.external_reason.describe,
        },
        observations: discharge.observations || "",
      },
      created_by,
      createdAt: now,
      updatedAt: now,
      __v: 0,
    };

    console.log(">>> MOCK RESPONSE GERADO:", mockResponse);

    yield put(submitDischargeSuccess(mockResponse));
    toast.success("Alta registrada com sucesso!");

    /*
    const response: AxiosResponse = yield call(
      apiSollar.post as any,
      `/apiV2/discharge`,
      {
        external_company_id,
        external_attendance_id,
        external_patient_id,
        discharge,
        created_by,
      }
    );
    yield put(submitDischargeSuccess(response.data));
    */
  } catch (error) {
    toast.error("Erro ao realizar a alta.");
    yield put(submitDischargeFailure());
  }
}
